import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import { applyCachedFavicon } from 'common/context/agency-theme/favicon'
import CustomHostBootstrap from 'common/tenant/custom-host-bootstrap'
import reportWebVitals from './reportWebVitals'

// Ultimo favicon da imobiliaria antes do React montar, para nao piscar o da
// Corretto (Feature FAVICON, decisao D5). O AgencyThemeProvider assume depois.
applyCachedFavicon()

ReactDOM.render(
  <React.StrictMode>
    <CustomHostBootstrap>
      <App />
    </CustomHostBootstrap>
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
